"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCodeValidationFailureType = void 0;
var DiscountCodeValidationFailureType;
(function (DiscountCodeValidationFailureType) {
    DiscountCodeValidationFailureType["Invalid"] = "invalid";
    DiscountCodeValidationFailureType["Expired"] = "expired";
    DiscountCodeValidationFailureType["AlreadyUsed"] = "alreadyUsed";
    DiscountCodeValidationFailureType["PaymentMethodNotSupported"] = "paymentMethodNotSupported";
    DiscountCodeValidationFailureType["CreditCardTypeNotSupported"] = "creditCardTypeNotSupported";
    DiscountCodeValidationFailureType["DepartureTooSoon"] = "departureTooSoon";
    DiscountCodeValidationFailureType["IncorrectStopsNumber"] = "incorrectStopsNumber";
    DiscountCodeValidationFailureType["IncorrectTripType"] = "incorrectTripType";
    DiscountCodeValidationFailureType["MinOrderPriceNotMet"] = "minOrderPriceNotMet";
    DiscountCodeValidationFailureType["NotValidForTravelAgent"] = "notValidForTravelAgent";
})(DiscountCodeValidationFailureType || (exports.DiscountCodeValidationFailureType = DiscountCodeValidationFailureType = {}));
//# sourceMappingURL=discount-code-validation-failure-type.enum.js.map